var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v("\n  "+_vm._s(_vm.hours)+"\n  "),_c('el-tag',{attrs:{"size":"mini"}},[_vm._v("h")]),_vm._v("\n  "+_vm._s(_vm.minutes)+"\n  "),_c('el-tag',{attrs:{"size":"mini"}},[_vm._v("m")]),_vm._v("\n  "+_vm._s(_vm.seconds)+"\n  "),_c('el-tag',{attrs:{"size":"mini"}},[_vm._v("s")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }